import { ExcelLikeGrid } from "../../../shared/excel-grid/components/ExcelLikeGrid";
import type { ExcelGridColumn } from "../../../shared/excel-grid/models/excel-grid.models";
import type { AdminOnboardingGridProps, AdminOnboardingRow } from "../../models/admin-onboarding.models";
import { ADMIN_ONBOARDING_COLUMNS } from "../../utils/admin-onboarding.constants";
import { ignoreAdminOnboardingCellCommit } from "../../utils/admin-onboarding.utils";
import { useMemo } from "react";

// Preserves the shared grid's column sorting, filters, and keyboard selection in a read-only table.
const AdminOnboardingGrid = ({ rows, disabled, onDeleteVessel }: AdminOnboardingGridProps) => {
  const columns = useMemo<ExcelGridColumn[]>(
    () => [
      ...ADMIN_ONBOARDING_COLUMNS,
      {
        key: "__actions",
        label: "Delete",
        editable: false,
        filterable: false,
        sortable: false,
        minWidth: 90,
        maxWidth: 90,
        renderCell: (row) => (
          <button
            type="button"
            data-test={`admin-onboarding-delete-${row.gridRowId}`}
            aria-label={`Delete onboarding for ${row.VESSEL_NAME}, IMO ${row.IMO_NUMBER ?? "unknown"}`}
            disabled={disabled || (!row.VESSEL_CODE && !row.IMO_NUMBER)}
            className="inline-flex h-8 items-center border border-[#BF0002] px-3 text-xs font-semibold text-[#BF0002] hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-gray-700"
            onClick={() => onDeleteVessel(row as AdminOnboardingRow)}
          >
            Delete
          </button>
        ),
      },
    ],
    [disabled, onDeleteVessel],
  );

  return (
    <ExcelLikeGrid
      rows={rows}
      columns={columns}
      dataTest="admin-onboarding-grid"
      onCellCommit={ignoreAdminOnboardingCellCommit}
      editingDisabled
      showHeadersWhenEmpty
      emptyLabel="No onboarding records match your search."
      rowHeight={44}
    />
  );
};

export default AdminOnboardingGrid;
